import React, { useEffect, useState } from "react";
import { ButtonBase, ModalBase } from "@reusejs/react";
import { useRouter } from "next/router";
import LoginFormModal from "../../components/authentication/LoginFromModal";
import { ChevronDownIcon } from "@heroicons/react/outline";
import { HeaderNavItems, Context } from "services";
import { DropdownMultiHover } from "@reusejs/react";
import Link from "next/link";

import { useSelector, useDispatch } from "react-redux";
import { clearAuth, clearGuestUser } from "store";

export default function AuthButtons(props: any) {
  const [profileDropdownItems, setProfileDropdownItems] = useState<any>();
  const { getStartActive } = props;

  const router = useRouter();
  const dispatch = useDispatch();
  const userToken = useSelector((state: any) => {
    return state.auth.accessToken;
  });
  const isLoggedIn = useSelector((state: any) => state.auth.user);
  const LoginFormWrapper = (props: any) => {
    return <LoginFormModal router={router} {...props} />;
  };

  const openModal = async () => {
    await ModalBase(
      {
        content: LoginFormWrapper,
        timeout: 0,
        backgroundColor: "bg-black/30",
        backgroundOpacity: "opacity-70",
        modalBaseClasses: {
          background: "bg-white",
          border: "border-2 rounded-lg",
          alignment: "text-left overflow-visible",
          padding: "p-0",
          small: "sm:my-8 sm:w-full sm:max-w-md",
        },
      },
      1000,
      "__next"
    );
  };

  const handleLogout = async () => {
    await fetch("/api/logout", {
      method: "GET",
      headers: { "Content-Type": "application/json" },
    });
    dispatch(clearAuth());
    dispatch(clearGuestUser());
    router.push("/");
  };

  const getNavigationItems = async () => {
    const data: any = HeaderNavItems();
    setProfileDropdownItems(data);
  };

  useEffect(() => {
    getNavigationItems();
  }, []);

  return (
    <div className="flow-root">
      <div className="flex lg:hidden">
        {userToken ? (
          <>
            {!getStartActive && (
              <div className="cursor-pointer hover:text-blue-700 mr-4">
                {isLoggedIn?.profile?.bio?.first_name
                  ? isLoggedIn.profile.bio.first_name
                  : isLoggedIn?.profile?.bio?.full_name
                  ? isLoggedIn?.profile?.bio?.full_name
                  : isLoggedIn?.profile?.name
                  ? isLoggedIn?.profile?.name
                  : "Guest"}
              </div>
            )}

            {getStartActive && (
              <div
                className="cursor-pointer hover:text-blue-700 mr-4"
                onClick={() => handleLogout()}
              >
                Logout
              </div>
            )}
          </>
        ) : (
          <div className="flex flex-row items-center">
            {!getStartActive && (
              <div
                className="w-16 md:w-20 md:pl-2 text-sm font-medium text-gray-700 hover:text-blue-700 cursor-pointer"
                onClick={() => openModal()}
              >
                Log In
              </div>
            )}

            {getStartActive && (
              <ButtonBase
                variant="primary"
                type="submit"
                label="Get Started"
                onClick={() => {
                  router.push("/signup");
                }}
                buttonBaseClasses={{
                  font: "text-sm font-medium",
                  backgroundColor: "bg-blue-600 hover:bg-blue-700",
                  textColor: "text-white",
                  border: "any",
                  width: "sm:w-full",
                  padding: "px-2 py-2  sm:px-0 sm:py-2",
                }}
              />
            )}
          </div>
        )}
      </div>
      <div className="hidden lg:flex">
        {userToken ? (
          <div className="relative flex">
            <div className="cursor-pointer flex justify-center items-center hover:text-blue-700">
              <span className="pr-2 text-sm">Welcome, </span>
              {/* <ChevronDownIcon height="16" width="16" /> */}
            </div>
            <div className="relative flex">
              {profileDropdownItems?.main.map((navItem: any, index: number) => {
                if (navItem.value === "profile") {
                  return (
                    <div className="flex" key={index}>
                      <div className="relative flex">
                        <DropdownMultiHover
                          dropdownMultiHoverClasses={{
                            containerClasses:
                              "absolute z-20 top-6 right-0 origin-top-left border dark:border-gray-800 bg-white dark:bg-gray-900 shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none  rounded-md",
                            childContainerClasses:
                              "absolute z-20 -top-1  w-60 right-0 origin-top-left translate-x-full border dark:border-gray-800 bg-white dark:bg-gray-900 py-1 rounded-md",
                            itemClasses:
                              "relative block w-full cursor-pointer px-4 py-2 text-sm text-gray-700 hover:bg-gray-50 hover:text-blue-600 dark:text-gray-100 dark:hover:bg-gray-700",
                          }}
                          label={() => (
                            <span className="relative z-10 -mb-px flex justify-center items-center border-b-2 border-transparent pt-px text-sm font-medium text-gray-700 transition-colors duration-200 ease-out hover:text-blue-600">
                              {isLoggedIn?.profile?.bio?.first_name
                                ? isLoggedIn.profile.bio.first_name
                                : isLoggedIn?.profile?.bio?.full_name
                                ? isLoggedIn?.profile?.bio?.full_name
                                : isLoggedIn?.profile?.name
                                ? isLoggedIn?.profile?.name
                                : "Guest"}
                              &nbsp;
                              <ChevronDownIcon height="16" width="16" />
                            </span>
                          )}
                          onClick={(item, index) => {
                            if (item.href != "/") router.push(item.href);
                            if (item.href == "/") {
                              handleLogout();
                            }
                          }}
                          items={profileDropdownItems?.profile}
                        />
                        {/* <div className="hidden">
                          <Link key={index} href={navItem.link}>
                            {navItem.label}
                          </Link>
                        </div> */}
                      </div>
                    </div>
                  );
                }
              })}
            </div>
          </div>
        ) : (
          <div className="flex flex-row items-center">
            <div
              className="w-20 text-sm font-medium text-gray-700 hover:text-blue-700 cursor-pointer"
              onClick={() => openModal()}
            >
              Log In
            </div>
            <ButtonBase
              variant="primary"
              type="submit"
              label="Get Started"
              onClick={() => {
                router.push("/signup");
              }}
              buttonBaseClasses={{
                font: "text-sm font-medium",
                backgroundColor: "bg-blue-600 hover:bg-blue-700",
                textColor: "text-white",
                border: "any",
                width: "sm:w-full",
                padding: "px-2 py-2  sm:px-0 sm:py-2",
              }}
            />
          </div>
        )}
      </div>
    </div>
  );
}
